module.exports = __webpack_public_path__ + "img/jhs_IOS.b3b6a75f.png";